module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--1.21dac2ed.svg";